/* eslint-disable */
import styled, { css } from 'styled-components';
import cssKit from '../../css';

const nissan = process.env.BRAND_NAME === 'nissan';

export const baseFontStyles = () => {
  return css`
    font-family: ${cssKit.fonts.regular};
    font-size: 10px;
    line-height: 12px;
    letter-spacing: 2px;

    ${cssKit.media.greaterThan('small') `
      font-size: 12px;
      line-height: 14px;
    `};
  `;
};

export const spanWithSpacing = () => {
  return css`
    display: inline-block;
    vertical-align: top;

    &:after {
      content: ', ';
      white-space: pre;
      display: inline;
    }
  `;
};

export const DealerCardWrapperStyled = styled.div`
  color: ${cssKit.vars.color_black_rgba(1)};
  margin: 0;
  border-bottom: 1px dotted #e1e1e1;
  border-top: 1px dotted #e1e1e1;
  padding: 12px 8px;
  background-color: #fff;

  ${cssKit.media.greaterThan('small') `
    padding: 12px;
  `};

  ${cssKit.media.greaterThan('medium') `
    margin: 10px 0;
    width: 800px;
  `};
`;

export const DealerInfoWrapperStyled = styled.div`
  display: inline-block;
  width: 50%;
  vertical-align: top;
  padding: 0 5px 0 0;

  ${cssKit.media.greaterThan('small') `
    width: 66.66%;
  `};
`;

export const DealerCardNameStyled = styled.h3`
  font-family: ${cssKit.fonts.bold};
  font-size: 16px;
  line-height: 18px;
  letter-spacing: 4px;
  color: ${cssKit.vars.color_black_rgba(1)};
  margin: 0 0 0 0;

  ${cssKit.media.greaterThan('small') `
    font-size: 18px;
    line-height: 20px;
  `};
`;

export const DealerCardAddressWrapperStyled = styled.div`
  ${baseFontStyles()};
  margin: 0;
`;

export const DealerCardAddressLineStyled = styled.span`
  display: block;
`;

export const DealerCardCityStateZipWrapperStyled = styled.div`
  display: inline-block;
  margin: 0;
`;

export const DealerCardCityStyled = styled.span`
  ${baseFontStyles()};
  ${spanWithSpacing()};
`;

export const DealerCardStateCodeStyled = styled.span`
  ${baseFontStyles()};
  ${spanWithSpacing()};
`;

export const DealerCardPostalCodeStyled = styled.span`
  display: inline-block;
  vertical-align: top;
  ${baseFontStyles()};
`;
export const DealerDistanceSelectWrapperStyled = styled.div`
  display: inline-block;
  width: 50%;
  vertical-align: bottom;

  ${cssKit.media.greaterThan('small') `
    width: 33.33%;
  `};
`;
export const DealerCardMilesAwayStyled = styled.div`
  margin: 0 0 10px 0;
  text-align: right;

  & span:nth-of-type(1) {
    display: block;
    font-family: ${cssKit.fonts.bold};
    font-size: 16px;
    line-height: 18px;
    letter-spacing: 4px;

    ${cssKit.media.greaterThan('small') `
      font-size: 18px;
      line-height: 20px;
    `};
  }
  & span:nth-of-type(2) {
    ${baseFontStyles()};
  }
`;

export const DealerCardSelectButtonWrapperStyled = styled.span`
  display: block;
  text-align: left;
  margin: 0 0 10px 0;
`;

export const StyledDealerPhoneNum = styled.div`
  font-family: ${cssKit.fonts.bold};
  color: ${nissan ? '#c51a47' : '#000'};
`;

/* eslint-enable */



/** WEBPACK FOOTER **
 ** ./src/components/DealerCard/styles.js
 **/